export const UPDATE_AUTH_NAMES_LIST = 'UPDATE_AUTH_NAMES_LIST';
export const AUTHORIZE_ACTIVE_JOB_REQUEST = 'AUTHORIZE_ACTIVE_JOB_REQUEST';
export const AUTHORIZE_ACTIVE_JOB_SUCCESS = 'AUTHORIZE_ACTIVE_JOB_SUCCESS';
export const AUTHORIZE_ACTIVE_JOB_NONE = 'AUTHORIZE_ACTIVE_JOB_NONE';
export const AUTHORIZE_ACTIVE_JOB_ERROR = 'AUTHORIZE_ACTIVE_JOB_ERROR';
export const AUTHORIZE_START_JOB_REQUEST = 'AUTHORIZE_START_JOB_REQUEST';
export const AUTHORIZE_START_JOB_SUCCESS = 'AUTHORIZE_START_JOB_SUCCESS';
export const AUTHORIZE_START_JOB_CONFLICT = 'AUTHORIZE_START_JOB_CONFLICT';
export const AUTHORIZE_START_JOB_ERROR = 'AUTHORIZE_START_JOB_ERROR';
export const AUTHORIZE_POLL_JOB_TICK = 'AUTHORIZE_POLL_JOB_TICK';
export const AUTHORIZE_POLL_JOB_RETRY = 'AUTHORIZE_POLL_JOB_RETRY';
export const AUTHORIZE_POLL_JOB_ERROR = 'AUTHORIZE_POLL_JOB_ERROR';
export const AUTHORIZE_JOB_TERMINAL = 'AUTHORIZE_JOB_TERMINAL';
export const AUTHORIZE_CLEAR_JOB_RESULT = 'AUTHORIZE_CLEAR_JOB_RESULT';
